import React, { Fragment } from 'react';
import styled from 'styled-components'
import data from '../../content/content.json'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import ContactForm from './ContactForm'

const styles = data.styles
const licenseLogo = require('../../images/icon_cc_heart.png')

const FooterContainer = styled.footer`
    background:${styles.colors.purplePrimary};
    color:${styles.colors.white};
    font-size: .77em;
    line-height: 18px;
    padding: 20px;
    @media (min-width: ${styles.breakpoints.m}px) {
        padding-top: 0;
    }
`
const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    margin: auto;
    max-width: 320px;
    @media (min-width: ${styles.breakpoints.m}px) {
        /* 3 columnas: licencia | W centrada | cooperativas */
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
        gap: 20px;
        max-width: calc(100% - 40px);
    }
    @media (min-width: ${styles.breakpoints.l}px) {
        max-width: 946px;
    }
`
// Isotipo W de Lawal, centrado. Se tinta en claro con mask (el PNG original es oscuro).
const FooterLogo = styled.div`
    width: 62px;
    height: 62px;
    flex-shrink: 0;
    /* En mobile va primera del stack. */
    order: -1;
    background: rgba(255, 255, 255, 0.9);
    -webkit-mask: url("/Lawal_Iso_w_oscuro.png") center / contain no-repeat;
    mask: url("/Lawal_Iso_w_oscuro.png") center / contain no-repeat;
    @media (min-width: ${styles.breakpoints.m}px) {
        width: 72px;
        height: 72px;
        order: 0;
    }
`
const FooterLicense = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    @media (min-width: ${styles.breakpoints.s}px) {
        width: auto;
    }    
`
const FooterLicenseName = styled.span`
    font-weight:${styles.fontWeight.bold};
`
const FooterCopyright = styled.div`
      text-align: center;
      @media (min-width: ${styles.breakpoints.m}px) {
          text-align: right;
      }
      @media (min-width: ${styles.breakpoints.l}px) {
          margin-top: 0;
      }
`
const FooterCoopName = styled.a`
    font-weight:${styles.fontWeight.bold};
    text-transform: uppercase;
    text-decoration: none;
    color: ${styles.colors.white};
    &:hover {
        color: ${styles.colors.greenMain}!important;
    }
`
const FooterLicenseContent = styled.p`
      max-width: 342px;
      margin-bottom: 25px;
      @media (min-width: ${styles.breakpoints.m}px) {
          max-width: 360px;
          margin-bottom: 0px;
      }
`
const FooterLicenseIcon = styled.img`
      width: 38px;
      height: 33px;
      margin-right: 6px;
`

const Footer = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <ContactForm/>
            <FooterContainer>
                <FooterWrapper>
                    <FooterLicense>
                        <FooterLicenseIcon src={licenseLogo.default} alt={t("footer.licenseIconAlt")} />
                        <FooterLicenseContent>
                            {t("footer.disclaimer")}  <FooterLicenseName>{t("footer.licenseName")}</FooterLicenseName>
                        </FooterLicenseContent>
                    </FooterLicense>
                    <FooterLogo aria-hidden />
                    <FooterCopyright>
                        {t("footer.designby")}{" "}
                        <FooterCoopName
                            type="link"
                            isLink={true}
                            href={t("footer.coopName1Path")}
                            target="_blank"
                        >
                        {t("footer.coopName1")}
                        </FooterCoopName>
                    {" "}{t("footer.preposition")}{" "}
                        <FooterCoopName
                            type="link"
                            isLink={true}
                            href={t("footer.coopName2Path")}
                            target="_blank"
                        >
                        {t("footer.coopName2")}
                        </FooterCoopName>
                    </FooterCopyright>
                </FooterWrapper>
            </FooterContainer>
        </Fragment>
    );
};

export default Footer;
